import { createAction, props } from '@ngrx/store';
import { multimapsResponse } from '@shared/interfaces/maps/multiMaps.interfaces';

export const loadCalculateRoutesSuccessByKey = createAction(
  '[Calculate Routes] Load Success By Key',
  props<{ key: string; response: multimapsResponse }>(),
);
